const ajaxPathCompanyModule = '/action/companyModule/';
const ajaxPathLicense = '/action/licenses';
let ajaxLockActive = false;
const ajaxPathBlockedCompany = '/action/blockedCompany';
const ajaxPathTicketIntegration = '/action/fticket-integration';
const ajaxPathTagConfig = '/action/tag'

const ticketIntegrationModalId = 'ticket_integration_modal';
const dealerConfigWrapperSelector = 'div#config-content-wrapper';
const ticketIntegrationDealerConfigSelector = 'div#ticket_integration';
const customerInfoTabId = 'customer_info_tab';

function triggerPricePopupForDealer(module, syncCode) {
    var modalId = 'dealer_price_input_modal';
    var moduleTitle = 'Modulen';

    // remove existing modal
    if ($('div#' + modalId).length) {
        $('div#' + modalId).remove();
    }

    // Save without comment right away, so dealer cant just close dialog and not save
    saveDealerModulePrice(module, syncCode, "", false);

    // launch popup
    var modal = '<div class="bootstrap-3-wrapper">' +
        '<div class="modal fade" id="' + modalId + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
        '  <div class="modal-dialog" role="document">' +
        '    <div class="modal-content">' +
        '      <div class="modal-header">' +
        '        <h4 class="modal-title" id="exampleModalLabel">Pris for ' + moduleTitle + '</h4>' +
        '      </div>' +
        '      <div class="modal-body form-horizontal">' +
        '        <p>' + getModulePrice(module) + ' Kr pr mnd eks MVA ut til kunde</p>' +
        '        <div class="row">' +
        '          <div class="col-sm-12">' +
        '           <textarea type="text" name="comment" placeholder="Kommentar/ønske om prisendring" class="form-control"></textarea>' +
        '          </div>' +
        '        </div>' +
        '      </div>' +
        '      <div class="modal-footer">' +
        // '        <button type="button" class="btn btn-default" data-dismiss="modal">Avbryt</button>' +
        '        <button type="button" class="btn btn-primary" id="save_button" module="' + module + '" sync_code="' + syncCode + '">Ok</button>' +
        '      </div>' +
        '    </div>' +
        '  </div>' +
        ' </div>' +
        '</div>';

    $('body').append(modal);

    $('div#' + modalId).modal({
        backdrop: 'static'
    });
}

function triggerTicketIntegrationPopupForDealer(syncCode) {
    $.ajax({
        type: 'GET',
        url: ajaxPathTicketIntegration + '/organizers',
        data: {},
        dataType: 'json'
    }).success(function (data) {
        launchTicketIntegrationPopup(syncCode, data.options);
    }).error(function (data) {
        alert('Kunne ikke hente tilgjengelige arrangører');
    });
    return false;
}

/**
 *
 * @param syncCode String
 * @param selectOptions String/HTML the options in the select list
 */
function launchTicketIntegrationPopup(syncCode, selectOptions) {
    let moduleTitle = 'Billettintegrasjon, velg konto';

    // remove existing modal
    if ($('div#' + ticketIntegrationModalId).length) {
        $('div#' + ticketIntegrationModalId).remove();
    }

    // launch popup
    var modal = '<div class="bootstrap-3-wrapper">' +
        '<div class="modal fade" id="' + ticketIntegrationModalId + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
        '  <div class="modal-dialog" role="document">' +
        '    <div class="modal-content">' +
        '      <div class="modal-header">' +
        '        <h4 class="modal-title" id="exampleModalLabel">' + moduleTitle + '</h4>' +
        '      </div>' +
        '      <div class="modal-body">' +
        '        <p>Velg arrangør som konto skal knyttes sammen med</p>' +
        '        <div class="row">' +
        '          <div class="col-sm-12">' +
        '           <select type="text" name="ticket_organizer" class="form-control chosen-select">' +
        '               ' + selectOptions +
        '           </select>' +
        '          </div>' +
        '        </div>' +
        '      </div>' +
        '      <div class="modal-footer">' +
        '        <button type="button" class="btn btn-primary" id="save_button" sync_code="' + syncCode + '">Ok</button>' +
        '      </div>' +
        '    </div>' +
        '  </div>' +
        ' </div>' +
        '</div>';

    $('body').append(modal);

    $('div#' + ticketIntegrationModalId).modal({
        backdrop: 'static'
    });

    // Activate searchable select list
    $('div#' + ticketIntegrationModalId + ' select.chosen-select').chosen({width: "50%"});
}

// Save ticket integration with selected organizer
$(document).on('click', 'div#' + ticketIntegrationModalId + ' button#save_button', function () {
    if (ajaxLockActive) {
        return;
    }

    ajaxLockActive = true;
    let syncCode = $(this).attr('sync_code');
    let organizerId = $('div#' + ticketIntegrationModalId + ' select[name="ticket_organizer"]').val();
    let organizerName = $('div#' + ticketIntegrationModalId + ' select[name="ticket_organizer"]  option:selected').text();

    $.ajax({
        type: 'POST',
        url: ajaxPathTicketIntegration,
        data: {
            organizer_id: organizerId,
            organizer_name: organizerName,
            sync_code: syncCode,
        },
        dataType: 'json'
    }).success(function () {
        $('div#' + ticketIntegrationModalId).modal('hide');
        updateTicketIntegrationDealerHtml(syncCode)
    }).error(function (data) {
        alert('Kunne ikke lagre integrasjon. ' + data.errors);
        $('div#' + ticketIntegrationModalId).modal('hide');
    }).always(function (data) {
        ajaxLockActive = false;
        $('div#' + ticketIntegrationModalId).modal('hide');
    })
});

function updateTicketIntegrationDealerHtml(syncCode) {
    $.ajax({
        type: 'GET',
        url: ajaxPathTicketIntegration + '/dealer-html',
        data: {
            sync_code: syncCode
        },
        dataType: 'json'
    }).success(function (data) {
        $(dealerConfigWrapperSelector + " " + ticketIntegrationDealerConfigSelector).html(data.html);
    }).error(function (data) {
        alert('Kunne ikke oppdatere visning av integrasjon, last siden på nytt. ' + data.errors);
    });
}

// Delete ticket integration   delete_ticket_integration
$(document).on('click', ticketIntegrationDealerConfigSelector + ' button#delete_ticket_integration', function () {
    if (!confirm('Vil du slette integrasjonen med billettsystemet for denne kontoen?')) {
        return;
    }

    let syncCode = $('div#' + customerInfoTabId + ' input#sync_code').val();

    $.ajax({
        type: 'DELETE',
        url: ajaxPathTicketIntegration + '/' + syncCode,
        dataType: 'json'
    }).success(function () {
        updateTicketIntegrationDealerHtml(syncCode);
    }).error(function (data) {
        alert('Kunne ikke slette billettintegrasjon: ' + data.errors);
    });
});

// Save price button clicked
$(document).on('click', '#dealer_price_input_modal button#save_button', function () {
    var module = $(this).attr('module');
    var syncCode = $(this).attr('sync_code');
    var comment = $('#dealer_price_input_modal textarea[name="comment"]').val();

    console.log('saving price for module');
    saveDealerModulePrice(module, syncCode, comment, true);
});

// Save price button clicked
$(document).on('click', 'button#ticket_integrated_button', function () {
    var syncCode = $(this).attr('sync_code');

    triggerTicketIntegrationPopupForDealer(syncCode)
});


function saveDealerModulePrice(module, syncCode, comment, closeDialogAfterSave) {
    $.ajax({
        type: 'POST',
        url: ajaxPathCompanyModule,
        data: {
            module: module,
            sync_code: syncCode,
            price_ex_vat_for_customer: getModulePrice(1 * module),
            comment: comment
        },
        dataType: 'json'
    }).success(function (data) {
        if (closeDialogAfterSave) {
            $('#dealer_price_input_modal').modal('hide');
        }
    }).error(function (data) {
        alert('Kunne ikke lagre pris.');
        if (closeDialogAfterSave) {
            $('#dealer_price_input_modal').modal('hide');
        }
    });
    return false;
}

function deleteDealerModulePrice(module, syncCode) {
    $.ajax({
        type: 'DELETE',
        url: ajaxPathCompanyModule,
        data: {
            module: module,
            sync_code: syncCode
        },
        dataType: 'json'
    }).success(function (data) {
        // Price info deleted
    }).error(function (data) {
        alert('Kunne ikke slette prisinformasjon for modul, vennligst send beskjed til teknisk.');
    });
    return false;
}

function deactivateModule(companyModuleId) {
    $.ajax({
        type: 'DELETE',
        url: ajaxPathCompanyModule,
        data: {
            company_module_id: companyModuleId
        },
        dataType: 'json'
    }).success(function (data) {
        // Price info deleted
    }).error(function (data) {
        alert('Kunne ikke slette prisinformasjon for modul, vennligst send beskjed til teknisk.');
    });
    return false;
}

function changeLicenseStatus(licenseKey, status, callableFunctionOnSuccess) {
    // Check that a save operation is not already in process
    if (ajaxLockActive) {
        return false;
    }
    ajaxLockActive = true;
    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'PUT',
        url: ajaxPathLicense + '/' + licenseKey,
        data: {
            status: status,
            processed_by_invoicing_department: 0
        },
        dataType: 'json'
    }).success(function () {
        $('div#license_action_wrapper').html('<div class="alert alert-success">Lagret</div>');
        if (callableFunctionOnSuccess !== false) {
            callableFunctionOnSuccess();
        }
    }).error(function (data) {
        displayAlertMessage('Kunne ikke endre status!', data.errors, 'danger');
    }).always(function () {
        ajaxLockActive = false;
    });
    return false;
}

function blockCompany(companyId, originButtonId, date) {
    if (isNaN(companyId)) {
        alert("Finner ikke tilknytning til company, kontakt teknisk");
        return;
    }

    var button = $('#' + originButtonId);

    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'POST',
        url: ajaxPathBlockedCompany,
        data: {
            company_id: companyId,
            date: date
        }
    }).success(function () {
        if (date != '') {
            alert('konto blir blokkert ' + date);
            button.html('Fjern fremtidig blokkering (Konto stenges rett før midnatt ' + date + ')');
        } else {
            alert('konto blokkert, hvis kassene er på nett vil blokkering synkes ned til kassene innen 10 minutter');
            button.html('Åpne bruk av konto og kasser');
        }

        button.removeClass('btn-danger');
        button.addClass('btn-success');
        button.attr('id', 'unblock_accounts_and_registers');
    }).error(function (data) {
        alert('Det oppstod en feil, kunne ikke blokkere konto');
    });
}

function unblockCompany(companyId, button) {
    if (isNaN(companyId)) {
        alert("Finner ikke tilknytning til company, kontakt teknisk");
        return;
    }

    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'DELETE',
        url: ajaxPathBlockedCompany,
        data: {
            company_id: companyId
        }
    }).success(function () {
        alert('konto åpnet, Kassene vil synkronisere info ved neste oppstart');
        button.removeClass('btn-success');
        button.addClass('btn-danger');
        button.attr('id', 'block_accounts_and_registers');
        button.html('Blokker bruk av konto og kasser');
    }).error(function (data) {
        alert('Det oppstod en feil, kunne ikke åpne konto');
    });
}

function getModulePrice(module) {
    switch (module) {
        case 1:
            return 0;
        case 2:
            return 200;
        case 3:
            return 150;
        case 4:
            return 150;
        case 5:
            return 990;
        case 6:
            return 0;
        case 7:
            return 500;
        case 8:
            return 0;
        case 9:
            return 500;
        case 10:
            return 590;
        case 11:
            return 195;
        case 12:
            return 590;
        case 13:
            return 590;
        default:
            return 0;
    }
}

/**
 *
 * @param parentElementInDOM element in which modal is appended
 * @param title
 * @param message
 * @param buttonText
 * @param alertType error, success, info
 */
function displayInfoMessageModal(parentElementInDOM, title, message, buttonText, alertType) {
    if ($("div#info_message_modal_wrapper", parentElementInDOM).length > 0) {
        $("div#info_message_modal_wrapper").remove();
    }

    let modalClass = '';
    let icon = '';
    switch (alertType) {
        case 'error':
            modalClass = 'error_modal';
            icon = '<i class="fa-solid fa-circle-exclamation"></i>';
            break;
        case 'success':
            modalClass = 'success_modal';
            icon = '<i class="fa-solid fa-check"></i>';
            break;
        case 'info':
            modalClass = 'info_modal';
            icon = '<i class="fa-solid fa-circle-question"></i>';
            break;
    }

    parentElementInDOM.append(
        '<div class="bootstrap-3-wrapper" id="info_message_modal_wrapper">\n' +
        '<div class="modal modal-backdrop" id="info_message_modal" tabindex="-1" role="dialog">\n' +
        '  <div class="modal-dialog modal-dialog-centered ' + modalClass + '" role="document">\n' +
        '    <div class="modal-content">\n' +
        '      <div class="modal-header">\n' +
        '        <h4 class="modal-title">' + icon + '  ' + title + '</h4>\n' +
        '      </div>\n' +
        '      <div class="modal-body bs-callout bs-callout-' + alertType +'">\n' +
        '        <h5>' + message + '</h5>\n' +
        '      </div>\n' +
        '      <div class="modal-footer">\n' +
        '        <button type="button" class="btn btn-default" data-dismiss="modal">' + buttonText + '</button>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '</div>\n' +
        '</div>');

    $("div#info_message_modal").modal("toggle");
}

/**
 * @param {Element} table
 * @param {number} columnToSort
 * @param {string} sortMethod numeric, alphabetic, d/m/Y
 * @param excludeLastTr
 */
function sortTable(table, columnToSort, sortMethod, excludeLastTr = false) {
    var rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        dir,
        switchcount = 0;
    switching = true;
    //Set the sorting direction to ascending:
    dir = "asc";

    let subtractFromRowsLength = 1;
    if (excludeLastTr === true) {
        subtractFromRowsLength = 2;
    }
    /*Make a loop that will continue until
    no switching has been done:*/
    while (switching) {
        //start by saying: no switching is done:
        switching = false;
        rows = table.find('> tbody > tr');
        /*Loop through all table rows (except the
        first, which contains table headers):*/
        for (i = 0; i < rows.length - subtractFromRowsLength; i++) {
            //start by saying there should be no switching:
            shouldSwitch = false;
            /*Get the two elements you want to compare,
            one from current row and one from the next:*/
            x = rows[i].getElementsByTagName("TD")[columnToSort];
            y = rows[i + 1].getElementsByTagName("TD")[columnToSort];
            /*check if the two rows should switch place,
            based on the direction, asc or desc:*/

            /*check if column content is numeric to cast the value to a number
             */
            let xValue = x.innerHTML.toLowerCase();
            let yValue = y.innerHTML.toLowerCase();
            if(sortMethod === 'numeric') {
                xValue = xValue.replace(',', '.') * 1;
                yValue = yValue.replace(',', '.') * 1;
            } else if (sortMethod == 'd/m/Y') {
                // month is 0-based, that's why we need dataParts[1] - 1
                let dateParts = xValue.split("/");
                xValue = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])

                dateParts = yValue.split("/");
                yValue = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
            }

            if (dir == "asc") {
                if (xValue > yValue) {
                    //if so, mark as a switch and break the loop:
                    shouldSwitch = true;
                    break;
                }
            } else if (dir == "desc") {
                if (xValue < yValue) {
                    //if so, mark as a switch and break the loop:
                    shouldSwitch = true;
                    break;
                }
            }
        }
        if (shouldSwitch) {
            /*If a switch has been marked, make the switch
            and mark that a switch has been done:*/
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            //Each time a switch is done, increase this count by 1:
            switchcount++;
        } else {
            /*If no switching has been done AND the direction is "asc",
            set the direction to "desc" and run the while loop again.*/
            if (switchcount == 0 && dir == "asc") {
                dir = "desc";
                switching = true;
            }
        }
    }
}

/*
     * Display html message
     *
     * If legend exist in form, the message is appended after legend
     * If legend does not exist in form, the message is appended after fieldset
     *
     * @param String headerText
     * @param String message
     * @param String type
     * @param HTML DOM prependToElement
     */
function displayAlertMessage(headerText, message, type, prependToElement) {
    // Remove any existing alert message
    removeAlertMessage();

    // Build html
    let HTMLMessage = '<div class="col-sm-12"><div class="alert alert-' + type + ' fade in" role="alert" id="alert_message">' +
        '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>' +
        '<h4 class="alert-heading">' + headerText + '</h4>' +
        '<p>' + message + '</p>' +
        '</div></div>';

    // Add message to element if it exists
    if (prependToElement.length) {
        prependToElement.prepend(HTMLMessage);
    }
}

/*
 * Remove bootstrap html message from form
 */
function removeAlertMessage() {
    // Check if an alert message exist
    if ($('div#alert_message').length) {
        // Remove alert div from form
        $('div#alert_message').remove();
    }
}

/*
 * Set Cookie
 */
function SetCookie(cookieName, value, expireDays = 0)
{
    let expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + expireDays);
    document.cookie = cookieName + "=" + escape(value) + ";expires=" + expireDate;
}

/**
 * The delay function will return a wrapped function that internally handles an individual timer,
 * in each execution the timer is restarted with the time delay provided,
 * if multiple executions occur before this time passes, the timer will just reset and start again.
 *
 * When the timer finally ends, the callback function is executed, passing the original context and arguments
 */
function delay(fn, ms) {
    let timer = 0
    return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
}

function copyToClipboard(valueToCopy, notifyElement, notifyPosition) {
    let temp = $("<input>");
    $("body").append(temp);
    temp.val(valueToCopy).select();

    try {
        let successful = document.execCommand('copy');
        notifyElement.notify(valueToCopy + ' ble kopiert til utklippstavlen', {position: notifyPosition, className: "success"});
        let msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
    } catch (err) {
        console.log('Oops, unable to copy');
    }
    temp.remove();
}

/**
 * Replaces HTML inside elements with a loading gif and adds the optional text to the right of the GIF
 * @param element
 * @param text default value: Henter data...
 */
function displayLoadingGifInElement(element, text = 'Henter data...') {
    element.html('<img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." style="margin-right: 10px;"/> ' + text);
}

/*
 * Notify.js is a jQuery plugin to provide simple yet fully customisable notifications.
 */
$.getScript("/htdocs/js/notify.min.js", function(){ });

/**
 * Adds a spinner to an element. Mainly used when saving a resource
 * @param buttonElement
 * @param buttonText
 */
function addSpinnerToButton(buttonElement, buttonText) {
    buttonElement.html('<span class="spinner-border spinner-border-sm"></span> ' + buttonText);
    buttonElement.prop("disabled", true);
}

/**
 * Removes a spinner from an element. Mainly used when saving a resource. Used in combination with function "addSpinnerToButton"
 * @param buttonElement
 * @param buttonText
 */
function removeSpinnerFromButton(buttonElement, buttonText) {
    buttonElement.html(buttonText);
    buttonElement.prop("disabled", false);
}

/**
 * Instantiate tooltip on page.
 * @param {string} divId
 * @param placement
 */
function activateToolTip(divId, placement = 'right') {
    $('div#' + divId + ' [data-toggle="tooltip"]').tooltip({
        placement: placement,
        html: true
    });
}

/**
 * Add a parameter to the browser URL without reload. Param is applied to the end of the current URL.
 * @param {string} param
 */
function addParameterToURL(param){
    let browserUrl = location.href;
    browserUrl += (browserUrl.split('?')[1] ? '&':'?') + param;
    window.history.replaceState(null, null, browserUrl);
}

function isValidJson(param) {
    try {
        JSON.parse(param);
        return true;
    } catch (e) {
        return false;
    }
}

function showPreloader() {
    if (!$('#preloader').length) {
        $('body').append(`<div id="preloader"><img src="/includes/article/images/loading.gif?v=1.000" style="width:25px; height: 25px;"/></div>`);
    }
}

function hidePreloader() {
    $('#preloader').remove();
}

function showTailwindPreloader() {
    if (!$('#tailwind_preloader').length) {
        $('body').append(`<div id='tailwind_preloader' class="fixed bg-theme-1 z-index-top bg-opacity-20 inset-0 flex flex-col items-center justify-center">
                <span class="h-16 w-16">
                    <svg class="h-full w-full" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#2d3748">
                        <g fill="none" fill-rule="evenodd" stroke-width="4">
                            <circle cx="22" cy="22" r="1">
                                <animate values="1; 20" attributeName="r" begin="0s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>
                                <animate values="1; 0" attributeName="stroke-opacity" begin="0s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>
                            </circle>
                            <circle cx="22" cy="22" r="1">
                                <animate values="1; 20" attributeName="r" begin="-0.9s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>
                                <animate values="1; 0" attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>
                            </circle>
                        </g> 
                    </svg>
                </span>
            </div>`);
    }
}

function hideTailwindPreloader() {
    $('#tailwind_preloader').remove();
}

function displayTailwindAlert(title = '', message = '', parentSelector = 'body', type = 'error', insertType = '', hide = false) {
    const colors = {
        success: 'alert relative border rounded-md px-5 py-4 bg-success border-success text-white dark:border-success',
        error: 'alert relative border rounded-md px-5 py-4 bg-danger border-danger text-white dark:border-danger',
        warning: 'alert relative border rounded-md px-5 py-4 bg-warning border-warning text-slate-900 dark:border-warning mb-2',
        info: 'alert relative border rounded-md px-5 py-4 bg-primary border-primary text-white dark:border-primary',
        gray: 'alert relative border rounded-md px-5 py-4 bg-secondary/70 border-secondary/70 text-slate-500 dark:border-darkmode-400 dark:bg-darkmode-400 dark:text-slate-300'
    };

    let titleHtml = '';
    if (title) {
        titleHtml = `<div class="text-lg font-medium">${title}</div>`;
    }

    let messageHtml = '';
    if (message) {
        messageHtml = `<div>${message}</div>`;
    }

    const alertHTML = `
        <div role="alert" 
             class="${colors[type] || colors.error} mt-2 ml-2 mr-2 mb-2 hidden flex gap-2">
          <div class="flex items-center">
            ${titleHtml}
          </div>
          ${messageHtml}
        </div>
      `;

    if (insertType === 'replace') {
        $(parentSelector).html(alertHTML);
    } else {
        $(parentSelector).append(alertHTML);
    }
    const $alert = $(parentSelector).find(".alert[role='alert']");


    if ($alert.length) {
        const instance = tailwind.Alert.getOrCreateInstance($alert[0]);

        $alert[0].addEventListener("hidden.tw.alert", (e) => {
            $(e.currentTarget).remove();
        });

        instance.show();

        if (hide) {
            setTimeout(() => instance.hide(), 10000);
        }
    }
}

function parseResponseError(data) {
    let message = 'Det oppsto en feil. Prøv igjen senere.';

    if (data.responseJSON && Array.isArray(data.responseJSON.errors) && data.responseJSON.errors.length > 0) {
        message = data.responseJSON.errors.join('<br>');
    } else {
        try {
            const parsedData = JSON.parse(data.responseText);
            const errors = parsedData.errors;

            if (Array.isArray(errors) && errors.length > 0) {
                message = errors.join('<br>');
            }
        } catch (e) {}
    }

    return message;
}

function dateTimeToTimestamp(dateTime) {
    if (!dateTime) {
        return 0;
    }
    const parts = dateTime.split(/[\s\/:]/);
    const date = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4]);
    return date.getTime();
}

/**
 * Display error messages in a modal
 *
 * @param title
 * @param data
 * @param parentElementSelector
 */
function showErrors(title, data, parentElementSelector = 'body') {
    let message = 'Det oppsto en feil. Prøv igjen senere.';

    if (data.responseJSON && Array.isArray(data.responseJSON.errors) && data.responseJSON.errors.length > 0) {
        message = data.responseJSON.errors.join('<br>');
    } else {
        try {
            const parsedData = JSON.parse(data.responseText);
            const errors = parsedData.errors;

            if (Array.isArray(errors) && errors.length > 0) {
                message = errors.join('<br>');
            }
        } catch (e) {}
    }

    displayInfoMessageModal($(parentElementSelector, document), title, message, 'Lukk', 'error');
}

/**
 * Reinitializes transition animations for elements with [data-transition].
 * Ensures that dynamically loaded tab sections or components correctly
 * trigger enter/leave animations when their attributes (like class "active") change.
 * Safe to call multiple times — observers are attached only once per element.
 *
 * For example, for Tab
 *
 * @param {Document|string} [context=document]
 */
function reinitTransitions(context = document) {
    const root = typeof context === 'string'
        ? document.querySelector(context)
        : context;

    if (!root) {
        console.error('context element not found');
        return;
    }

    let contextObject;
    if (context === document) {
        contextObject = $(context);
    } else {
        contextObject = $(context, document);
    }

    const lastActive = new WeakMap();

    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            if (m.type !== "attributes" || m.attributeName !== "class") continue;

            const el = m.target;
            const isActive = el.classList.contains("active");
            const prev = lastActive.get(el);

            if (prev === undefined) {
                lastActive.set(el, isActive);
                continue;
            }

            if (prev !== isActive) {
                lastActive.set(el, isActive);
                handleTransition(el);
            }
        }
    });

    contextObject.find("[data-transition]").each(function () {
        const el = this;

        if (!el.__transitionObserved) {
            observer.observe(el, {
                attributes: true,
                attributeFilter: ["class"]
            });
            el.__transitionObserved = true;
        }

        lastActive.set(el, el.classList.contains("active"));
        handleTransition(el);
    });

    // Core transition logic (based on the original Tailwind script)
    function handleTransition(t) {
        const $t = $(t);

        // console.log($t)
        const a = $t.clone().html("");
        const hasActive = $($("<div></div>").append(a)).find($(a).data("selector")).length;

        if ($t.data("state") === undefined) {
            $t.data("state", hasActive ? "leave" : "enter");
            hasActive ? $t.show() : $t.hide();
        }

        if (hasActive && $t.data("state") === "leave") {
            $t.data("state", "enter");
            $t.show();
            $t.addClass($t.data("enter-from"));

            setTimeout(() => {
                $t.addClass($t.data("enter"));
                $t.addClass($t.data("enter-to"));
                $t.removeClass($t.data("enter-from"));

                setTimeout(() => {
                    $t.removeClass($t.data("enter"));
                }, parseFloat($t.css("transition-duration")) * 1000);
            });
        } else if (!hasActive && $t.data("state") === "enter") {
            $t.data("state", "leave");
            $t.addClass($t.data("leave-from"));

            setTimeout(() => {
                $t.addClass($t.data("leave"));
                $t.addClass($t.data("leave-to"));
                $t.removeClass($t.data("leave-from"));

                setTimeout(() => {
                    $t.removeClass($t.data("leave"));
                    const current = $t.attr("class") || "";
                    $t.attr(
                        "class",
                        current.split(" ").filter(d => d.search("mt-") === -1).join(" ")
                    );

                    setTimeout(() => {
                        $t.hide();
                    }, 100);
                }, parseFloat($t.css("transition-duration")) * 1000);
            });
        }
    }
}





/**
 * Notify.js is a jQuery plugin to provide simple yet fully customisable notifications.
 */
$.getScript("/htdocs/js/notify.min.js", function(){ });

